import logo from "@src/assets/whiteBIT.svg";
import ChangeLanguage from "@src/components/shared/ChangeLanguage";

function Header() {
  return (
    <div className="bg-whitebitBlack p-4  text-white sm:px-6 md:px-8 lg:px-12 xl:px-[120px] fixed top-0 left-0 right-0 z-50">
      <div className="mx-auto flex max-w-[1280px] items-center justify-between">
        <img alt="logo" className="h-5 w-auto" src={logo} />
        <ChangeLanguage />
      </div>
    </div>
  );
}

export default Header;
